import React from 'react';
import "../components/styles/footer.css";

function Footer() {
    const currentYear = new Date().getFullYear();
    return (
        <footer className='footer'>
            <p className='footer-text'>© {currentYear} Abdur. All Rights Reserved</p>
        </footer>
    );
}

export default Footer;